/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".clientList[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:nth-child(2n+1){background-color:rgba(0,0,0,.05)}\n/*# sourceMappingURL=client-list.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin/client-list/client-list.component.css.shim.ngstyle.js.pre-build-optimizer.js